import {
  ObjectCondition,
  ObjectTrigger,
  SceneLockState,
} from '@/../client-generator/generated-clients/plants';
import EnumToRadioButton from '@/views/components/EnumToRadioButton/EnumToRadioButton.vue';
import { Options } from 'vue-class-component';
import SceneTriggerAndConditionGeneral from '../SceneTriggerAndConditionGeneral';

@Options({
  name: 'TriggerAndConditionLock',
  components: {
    EnumToRadioButton,
  },
})
export default class TriggerAndConditionLock extends SceneTriggerAndConditionGeneral {
  SceneLockState = SceneLockState;
  declare triggerOrActionToAdd: ObjectTrigger | ObjectCondition;

  get isConfirmEnabled() {
    return this.triggerOrActionToAdd.lockState != SceneLockState.None;
  }
}
